import "./eventsList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import EventsTable from "../eventstable/EventsTable";

const EventsList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <EventsTable />
      </div>
    </div>
  );
};

export default EventsList;
